import type { SVGProps } from "react";
const SvgMinus = (props: SVGProps<SVGSVGElement>) => <svg fill="none" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M5.25 12h14" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} /></svg>;
export default SvgMinus;
export { SvgMinus };